var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMirageWallet(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 6,
    fill: "#FDFF5D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.6425 24.3744L22.3117 18.2699C22.2103 18.0391 22.0076 17.8852 21.7543 17.8852H20.8169C20.5635 17.8852 20.3355 17.7313 20.2595 17.5005L16.4592 7.60001H12.9883L9.28936 17.0388C9.13735 17.4492 9.41604 17.8852 9.84674 17.8852C10.2774 17.8852 10.5561 18.3212 10.4041 18.7316L8.19995 24.4H24.6425V24.3744ZM14.6351 10.6009L17.27 17.4748C17.3713 17.7057 17.574 17.8595 17.8273 17.8595H18.7647C19.0181 17.8595 19.2461 18.0134 19.3221 18.2443L20.6902 21.8095H12.1522L13.343 18.6803C13.495 18.2699 13.191 17.8595 12.7856 17.8595H12.735C12.3043 17.8595 12.0256 17.4235 12.1776 17.0388L14.6351 10.6009Z",
    fill: "#131313"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMirageWallet);
export default __webpack_public_path__ + "static/media/mirage-wallet.d1b046ea.svg";
export { ForwardRef as ReactComponent };